<div *hasScope="SCOPES.ORDERS.UNDELIVER">
  <app-order-action-popup
    #undeliverPopup
    type="detailed"
    [loading]="undelivering()"
    [optionData]="undeliveredReasons()"
    [showOtherReason]="true"
    [otherReasonId]="0"
    [label]="isArabic() ? 'تعليق' : 'Comment'"
    (submit)="
      onUndeliverOrder(undeliverPopup.selectedReasonId(), undeliverPopup.otherReason(), undeliverPopup.comment())
    "
    [title]="isArabic() ? 'إلغاء التسليم' : 'Undeliver Order'"
    (closePopup)="onCloseUndeliver()"
    [err]="errorShip()"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من عدم تسليم جميع الأصناف في هذا الطلب؟'
        : 'Are you sure you want to mark all items as undelivered?'
    "
    [submitBtnContent]="isArabic() ? 'إلغاء التسليم' : 'Undeliver'"
    [detailedLabel]="isArabic() ? 'سبب عدم التسليم' : 'Undeliver Reason'"
    [optionOne]="isArabic() ? 'حدد السبب لعدم تسليم هذا الطلب' : 'Select the reason for undelivering this order'" />

  @if (undeliverSuccess()) {
    <app-successful-notification
      type="success"
      [title]="
        isArabic() ? 'تم تسجيل الطلب كغير مُسلم بنجاح.' : 'Order has been marked as undelivered successfully.'
      " />
  }
</div>
